import { createSlice } from "@reduxjs/toolkit";

export const ScanUploadSlice = createSlice({
    name:'scanupload',
    initialState: {
        show: false,
        fileName: "",
        machineStart: -1,
        motorStop: -1,
        note: "",
        contents: "",
        auid: ""
    },
    reducers: {
        uploadShow: (state, action) => {
            return {
                ...state,
                show: true,
                auid: action.payload.auid,
            }
        },
        uploadHide: (state, action) => {
            return {
                ...state,
                show: false,
                fileName: "",
                machineStart: -1,
                motorStop: -1,
                note: "",
                contents: ""
            }
        },
        uploadSetFileName: (state, action) => {
            return {
                ...state,
                fileName: action.payload.fileName,
            }
        },
        uploadSetMachineStart: (state, action) => {
            return {
                ...state,
                machineStart: action.payload.machineStart
            }
        },
        uploadSetMotorStop: (state, action) => {
            return {
                ...state,
                motorStop: action.payload.motorStop
            }
        },
        uploadSetNote: (state, action) => {
            return {
                ...state,
                note: action.payload.note
            }
        },
        uploadSetContents: (state, action) => {
            return {
                ...state,
                contents: action.payload.contents
            }
        }
    }
})

export const { uploadShow, uploadHide, uploadSetFileName, uploadSetMachineStart, uploadSetMotorStop, uploadSetNote, uploadSetContents } = ScanUploadSlice.actions

export default ScanUploadSlice.reducer